import { render } from "./AppointmentConfirmCard.vue?vue&type=template&id=e59af55c&scoped=true"
import script from "./AppointmentConfirmCard.vue?vue&type=script&lang=js"
export * from "./AppointmentConfirmCard.vue?vue&type=script&lang=js"

import "./AppointmentConfirmCard.vue?vue&type=style&index=0&id=e59af55c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e59af55c"]])

export default __exports__